import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '../ui/Button';
import { DemoDialog } from '../DemoDialog';
import { ContactDialog } from '../ContactDialog';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '../ui/DropdownMenu';
import { ChevronDown, Menu, X } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/iq6hvRZthzFQJZFoS3ADtj/meetOS-2.png';
const NAV_LINKS_BEFORE_EVENT = [{
  to: '/plateforme',
  label: 'La Plateforme'
}];
const NAV_LINKS_AFTER_EVENT = [{
  to: '/infrastructure',
  label: 'Infrastructure'
}, {
  to: '/tarifs',
  label: 'Tarifs'
}];
const EVENT_PHASES = [{
  to: '/avant',
  label: "Avant l'événement"
}, {
  to: '/pendant',
  label: "Pendant l'événement"
}, {
  to: '/apres',
  label: "Après l'événement"
}];
export function Navbar() {
  const location = useLocation();
  const [isEventDropdownOpen, setIsEventDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const isEventPhaseActive = EVENT_PHASES.some(phase => location.pathname === phase.to);
  return <>
      <nav className="sticky top-0 z-50 w-full border-b border-white/[0.08] backdrop-blur-sm font-heading" style={{
      backgroundColor: 'rgba(9, 9, 11, 0.92)'
    }} data-id="element-538">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16" data-id="element-539">
          <Link to="/" className="flex-shrink-0" data-id="element-540">
            <img src={LOGO_URL} alt="MeetOS" className="h-8 w-auto brightness-0 invert" data-id="element-541" />
          </Link>

          <div className="hidden lg:flex items-center gap-1" data-id="element-542">
            {NAV_LINKS_BEFORE_EVENT.map(link => <Link key={link.to} to={link.to} className={`px-3 py-2 text-sm font-medium transition-colors rounded-md ${location.pathname === link.to ? 'text-white bg-white/[0.08]' : 'text-white/60 hover:text-white'}`} data-id="element-543">
                {link.label}
              </Link>)}

            <DropdownMenu open={isEventDropdownOpen} onOpenChange={setIsEventDropdownOpen} data-id="element-544">
              <DropdownMenuTrigger asChild data-id="element-545">
                <button className={`px-3 py-2 text-sm font-medium transition-colors rounded-md flex items-center gap-1 ${isEventPhaseActive ? 'text-white bg-white/[0.08]' : 'text-white/60 hover:text-white'}`} data-id="element-546">
                  L'événement
                  <ChevronDown className={`w-4 h-4 transition-transform ${isEventDropdownOpen ? 'rotate-180' : ''}`} data-id="element-547" />
                </button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="bg-[#09090B] border-white/[0.08] backdrop-blur-sm min-w-[200px]" data-id="element-548">
                {EVENT_PHASES.map(phase => <DropdownMenuItem key={phase.to} asChild data-id="element-549">
                    <Link to={phase.to} className={`w-full px-3 py-2 text-sm cursor-pointer transition-colors ${location.pathname === phase.to ? 'text-white bg-white/[0.08]' : 'text-white/60 hover:text-white hover:bg-white/[0.04]'}`} data-id="element-550">
                      {phase.label}
                    </Link>
                  </DropdownMenuItem>)}
              </DropdownMenuContent>
            </DropdownMenu>

            {NAV_LINKS_AFTER_EVENT.map(link => <Link key={link.to} to={link.to} className={`px-3 py-2 text-sm font-medium transition-colors rounded-md ${location.pathname === link.to ? 'text-white bg-white/[0.08]' : 'text-white/60 hover:text-white'}`} data-id="element-551">
                {link.label}
              </Link>)}

            <ContactDialog data-id="element-552">
              <button className="px-3 py-2 text-sm font-medium transition-colors rounded-md text-white/60 hover:text-white" data-id="element-553">
                Contact
              </button>
            </ContactDialog>
          </div>

          <div className="flex items-center gap-3" data-id="element-554">
            <DemoDialog data-id="element-555">
              <Button size="sm" className="bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-600 hover:to-blue-600 text-white border-0 px-5 shadow-sm" data-id="element-556">
                Demander une démo
              </Button>
            </DemoDialog>

            {/* Mobile menu button */}
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="lg:hidden p-2 text-white/60 hover:text-white transition-colors" aria-label="Toggle menu" data-id="element-557">
              <Menu className="w-6 h-6" data-id="element-558" />
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile menu overlay - rendered outside nav to escape stacking context */}
      {isMobileMenuOpen && <>
          {/* Backdrop */}
          <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[60] lg:hidden" onClick={() => setIsMobileMenuOpen(false)} data-id="element-559" />

          {/* Mobile menu panel */}
          <div className="fixed top-0 right-0 bottom-0 w-full max-w-sm bg-[#09090B] border-l border-white/[0.08] z-[70] lg:hidden overflow-y-auto" data-id="element-560">
            <div className="flex items-center justify-between p-4 border-b border-white/[0.08]" data-id="element-561">
              <img src={LOGO_URL} alt="MeetOS" className="h-8 w-auto brightness-0 invert" data-id="element-562" />
              <button onClick={() => setIsMobileMenuOpen(false)} className="p-2 text-white/60 hover:text-white transition-colors" aria-label="Close menu" data-id="element-563">
                <X className="w-6 h-6" data-id="element-564" />
              </button>
            </div>

            <div className="p-4 space-y-2" data-id="element-565">
              {NAV_LINKS_BEFORE_EVENT.map(link => <Link key={link.to} to={link.to} onClick={() => setIsMobileMenuOpen(false)} className={`block px-4 py-3 text-base font-medium transition-colors rounded-lg ${location.pathname === link.to ? 'text-white bg-white/[0.08]' : 'text-white/60 hover:text-white hover:bg-white/[0.04]'}`} data-id="element-566">
                  {link.label}
                </Link>)}

              <div className="pt-2 border-t border-white/[0.08] mt-4" data-id="element-567">
                <div className="px-4 py-2 text-xs font-semibold text-white/40 uppercase tracking-wider" data-id="element-568">
                  L'événement
                </div>
                {EVENT_PHASES.map(phase => <Link key={phase.to} to={phase.to} onClick={() => setIsMobileMenuOpen(false)} className={`block px-4 py-3 text-base font-medium transition-colors rounded-lg ${location.pathname === phase.to ? 'text-white bg-white/[0.08]' : 'text-white/60 hover:text-white hover:bg-white/[0.04]'}`} data-id="element-569">
                    {phase.label}
                  </Link>)}
              </div>

              {NAV_LINKS_AFTER_EVENT.map(link => <Link key={link.to} to={link.to} onClick={() => setIsMobileMenuOpen(false)} className={`block px-4 py-3 text-base font-medium transition-colors rounded-lg ${location.pathname === link.to ? 'text-white bg-white/[0.08]' : 'text-white/60 hover:text-white hover:bg-white/[0.04]'}`} data-id="element-570">
                  {link.label}
                </Link>)}

              <ContactDialog data-id="element-571">
                <button className="block w-full text-left px-4 py-3 text-base font-medium transition-colors rounded-lg text-white/60 hover:text-white hover:bg-white/[0.04]" data-id="element-572">
                  Contact
                </button>
              </ContactDialog>
            </div>
          </div>
        </>}
    </>;
}